export default __webpack_public_path__ + "static/media/38.3222ef27.png";